// StakeDetails.jsx 
import React, { useState } from 'react';
import './StakeDetails.css';

const IntroContent = () => (
    <div className="intro-content animate-fade-in">
      <div className="info-cards">
        <div className="info-card">
          <h3>Reward Tokens</h3>
          <p className="highlight-text">Earn $BASED and $REDACTED for staking $bSIM.</p>
          <p className="detail-text">Lock tokens longer for higher multipliers, up to *TBD* base rate. Base APY varies based on staked amount and time.</p>
        </div>
        <div className="info-card">
          <h3>Voting Power</h3>
          <p className="highlight-text">Gain voting power through staking.</p>
          <p className="detail-text">Longer lock periods grant increased voting power multipliers. Vote on $BASED emissions and implementations.</p>
        </div>
        <div className="info-card">
          <h3>Network Earnings</h3>
          <p className="highlight-text">Earn more for supporting the Simulation.</p>
          <p className="detail-text">Earn $BASED emissions and $REDACTED for providing power to the SIM.</p>
        </div>
      </div>
      
      <div className="info-message">
        <p>*Data In These Sections Is Subject To Change*</p>
      </div>
    </div>
);

const StakingTiersContent = () => {
  const stakingTiers = [
    { months: 1, rewardMult: 100, votingMult: 100 },
    { months: 2, rewardMult: 105, votingMult: 110 },
    { months: 3, rewardMult: 110, votingMult: 120 },
    { months: 6, rewardMult: 125, votingMult: 150 },
    { months: 12, rewardMult: 150, votingMult: 200 },
    { months: 18, rewardMult: 175, votingMult: 250 },
    { months: 24, rewardMult: 200, votingMult: 300 },
    { months: 30, rewardMult: 225, votingMult: 350 },
    { months: 36, rewardMult: 250, votingMult: 400 }
  ];

  return (
    <div className="staking-section animate-fade-in">
      <div className="stake-cards">
        <div className="stake-card">
          <h3>Base APY</h3>
          <p className="value">95%</p>
        </div>
        <div className="stake-card">
          <h3>Max Reward Supply</h3>
          <p className="value">250M Tokens</p>
        </div>
      </div>
      
      <div className="tiers-table">
        <table>
          <thead>
            <tr>
              <th>Lock Period</th>
              <th>Reward Multiplier</th>
              <th>Voting Power</th>
              <th>Effective APY</th>
            </tr>
          </thead>
          <tbody>
            {stakingTiers.map(tier => (
              <tr key={tier.months}>
                <td>{tier.months} Month{tier.months > 1 ? 's' : ''}</td>
                <td>{tier.rewardMult}%</td>
                <td>{tier.votingMult}%</td>
                <td>{(95 * tier.rewardMult / 100).toFixed(2)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const CVTiersContent = () => {
    const tiers = [
      // Creature Tiers
      { category: "Creature", acceptance: "100%", rewardMult: "TBD" },
      { category: "Creature", acceptance: "80%", rewardMult: "TBD" },
      { category: "Creature", acceptance: "60%", rewardMult: "TBD" },
      { category: "Creature", acceptance: "40%", rewardMult: "TBD" },
      { category: "Creature", acceptance: "20%", rewardMult: "TBD" },
      // Separator row will be handled in render
      // Validator Tiers
      { category: "Validator", acceptance: "100%", rewardMult: "TBD" },
      { category: "Validator", acceptance: "80%", rewardMult: "TBD" },
      { category: "Validator", acceptance: "60%", rewardMult: "TBD" },
      { category: "Validator", acceptance: "40%", rewardMult: "TBD" },
      { category: "Validator", acceptance: "20%", rewardMult: "TBD" }
    ];
  
    return (
      <div className="cv-section animate-fade-in">
        <div className="stake-cards">
        <div className="stake-card">
          <h3>Emissions</h3>
          <div className="values-row">
          <p className="value">$BASED</p>
          <p className="value">$REDACTED</p>
        </div>
        </div>
        <div className="stake-card">
          <h3>Max Reward Supply</h3>
          <p className="value">50M-100M Tokens</p>
        </div>
      </div>
      
        <div className="tiers-table">
          <table>
            <thead>
              <tr>
                <th>Category</th>
                <th>Acceptance Rate</th>
                <th>Reward Multiplier</th>
              </tr>
            </thead>
            <tbody>
              {tiers.map((tier, index) => (
                  <tr key={`${tier.category}-${tier.type}`}>
                    <td>{tier.category}</td>
                    <td>{tier.acceptance}</td>
                    <td>{tier.rewardMult}</td>
                  </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

const StakeDetails = () => {
  const [activeSection, setActiveSection] = useState(null);

  return (
    <section className="stake-details">
      <div className="container">
        <div className="section-headers">
          <h2 
            className={`section-title ${activeSection === 'staking' ? 'active' : ''}`}
            onClick={() => setActiveSection(activeSection === 'staking' ? null : 'staking')}
          >
            Staking Tiers
          </h2>
          <h2 
            className={`section-title center ${activeSection === null ? 'active' : ''}`}
            onClick={() => setActiveSection(null)}
          >
            Rewards & Power
          </h2>
          <h2 
            className={`section-title ${activeSection === 'cv' ? 'active' : ''}`}
            onClick={() => setActiveSection(activeSection === 'cv' ? null : 'cv')}
          >
            C & V Tiers
          </h2>
        </div>

        <div className="section-content">
          {activeSection === null ? (
            <IntroContent />
          ) : activeSection === 'staking' ? (
            <StakingTiersContent />
          ) : (
            <CVTiersContent />
          )}
        </div>
      </div>
    </section>
  );
};

export default StakeDetails;